import { createVar, globalStyle, style } from '@vanilla-extract/css';

const headerOffset = createVar();

export const pageContainer = style({
  vars: {
    [headerOffset]: '0px',
    '--campaign-page-header-space': `calc(var(--page-header-control-top) + var(--page-header-control-height) + var(--page-header-reserved-bottom-space) + ${headerOffset})`,
  },
  '@media': {
    '(max-width: 919px)': {
      vars: { [headerOffset]: '120px' },
    },
  },
});

export const headerRow = style({ marginTop: headerOffset });

globalStyle(`${pageContainer}.pageContainer-campaignsSection .contentContainerStickyHeader`, {
  vars: {
    '--task-collapsible-header-top':
      'calc(var(--sub-page-heading-pad-top) + var(--sub-page-heading-height) - var(--campaign-sticky-band-overlap))',
    '--sub-page-left-menu-top':
      'calc(var(--sub-page-heading-pad-top) + var(--sub-page-heading-height) + var(--sub-page-divider-height) - var(--campaign-sticky-band-overlap))',
  },
});

globalStyle(
  `${pageContainer}.pageContainer-campaignsSection .contentContainerStickyHeader #subPageHeadingContainer, ${pageContainer}.pageContainer-campaignsSection .sideMenuContainer`,
  { top: 'calc(-1 * var(--campaign-sticky-band-overlap))' }
);
